/* tslint:disable */
/* eslint-disable */
/* @relayHash 58570c4a1b58a68dc29a191bf85d302c */

import { ConcreteRequest } from "relay-runtime";
export type PendingBackgroundCheckTab_UpdateDBSExpiryMutationVariables = {
    backgroundCheckUUID: string;
    date: string;
};
export type PendingBackgroundCheckTab_UpdateDBSExpiryMutationResponse = {
    readonly updateDBSExpiryDate: boolean;
};
export type PendingBackgroundCheckTab_UpdateDBSExpiryMutation = {
    readonly response: PendingBackgroundCheckTab_UpdateDBSExpiryMutationResponse;
    readonly variables: PendingBackgroundCheckTab_UpdateDBSExpiryMutationVariables;
};



/*
mutation PendingBackgroundCheckTab_UpdateDBSExpiryMutation(
  $backgroundCheckUUID: UUID!
  $date: Time!
) {
  updateDBSExpiryDate(backgroundCheckUUID: $backgroundCheckUUID, date: $date)
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "backgroundCheckUUID",
            "type": "UUID!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "date",
            "type": "Time!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "updateDBSExpiryDate",
            "args": [
                {
                    "kind": "Variable",
                    "name": "backgroundCheckUUID",
                    "variableName": "backgroundCheckUUID"
                },
                {
                    "kind": "Variable",
                    "name": "date",
                    "variableName": "date"
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "PendingBackgroundCheckTab_UpdateDBSExpiryMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "PendingBackgroundCheckTab_UpdateDBSExpiryMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "PendingBackgroundCheckTab_UpdateDBSExpiryMutation",
            "id": null,
            "text": "mutation PendingBackgroundCheckTab_UpdateDBSExpiryMutation(\n  $backgroundCheckUUID: UUID!\n  $date: Time!\n) {\n  updateDBSExpiryDate(backgroundCheckUUID: $backgroundCheckUUID, date: $date)\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '8270a17ffe97aa7499eb49b9203a514e';
export default node;
